import { memo } from 'react'
import {
  useCurrentNetwork,
  useIsErrorChain,
  useSupportChains,
} from 'store/app/hooks'
import { NetworkIcon } from './Popup.styles'
import { CurrentNetwork, SwitchNetwork } from './Current.styles'

export const NetworkSelectCurrent = memo(() => {
  const isErrorChain = useIsErrorChain()
  const currentNetwork = useCurrentNetwork()

  const supportChains = useSupportChains()
  const iconUrl = currentNetwork?.iconUrl ?? supportChains?.[0]?.iconUrl

  return (
    <CurrentNetwork $isErrorChain={isErrorChain}>
      {isErrorChain ? (
        <SwitchNetwork>
          Switch <span>Network</span>
        </SwitchNetwork>
      ) : (
        <NetworkIcon src={iconUrl} style={{ borderRadius: '50%' }} />
      )}
    </CurrentNetwork>
  )
})
